import { useState, useEffect, useRef } from "react";
import teamHeroImg from "../../../src/assests/internship-team.png";
import "./Internship.css";

// Internship.jsx
// Production API endpoint
const INTERNSHIP_API_URL =
  "https://skillsyncpro.in/backend-php/internship_apply.php";

async function submitInternshipApplication(form) {
  const response = await fetch(INTERNSHIP_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      name: form.name.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      domain: form.domain,
      message: form.message.trim(),
    }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Keep a useful error if the server returned non-JSON.
  }

  if (!response.ok) {
    throw new Error(
      data?.message || `Application failed (HTTP ${response.status}).`
    );
  }

  return data;
}

/* ── Static domain data — mirrors the approved page design.
   Not backend-driven because these tracks are fixed program
   offerings, not something that changes like a job listing. ── */
const DOMAINS = [
  {
    key: "Python Programming",
    title: "Python Programming",
    duration: "2 – 3 Months",
    stack: "Python, OOP, Data Structures, Automation",
    color: "#2f9e5b",
    bg: "#e6f6ec",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3c-3 0-4.5 1.2-4.5 3v2.4h4.8v.6H5.7C4 9 3 10.4 3 12.6c0 2.2 1 3.6 2.7 3.6h1.5v-2.1c0-2 1.5-3.3 3.4-3.3h3.6c1.7 0 3-1.3 3-3V6c0-1.8-1.5-3-4.2-3h-1z" strokeLinejoin="round" />
        <path d="M12 21c3 0 4.5-1.2 4.5-3v-2.4h-4.8v-.6h6.6c1.7 0 2.7-1.4 2.7-3.6 0-2.2-1-3.6-2.7-3.6h-1.5v2.1c0 2-1.5 3.3-3.4 3.3H9.8c-1.7 0-3 1.3-3 3V18c0 1.8 1.5 3 4.2 3h1z" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    key: "Java Programming",
    title: "Java Programming",
    duration: "2 – 3 Months",
    stack: "Core Java, OOP, Spring Boot, MySQL",
    color: "#e0703a",
    bg: "#fdece1",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M7 3c-2 3 6 3.5 4 7M7.5 12c-3 1-1.5 4 4.5 4 5.5 0 7.5-1.6 7.5-3.2 0-1.1-1-1.9-2.3-2.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 17.5c-1 .6-.4 1.7 1.6 1.9 4 .4 8-.4 8-2.1" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    key: "Artificial Intelligence",
    title: "Artificial Intelligence",
    duration: "2 – 3 Months",
    stack: "Python, ML Basics, Neural Networks, AI Tools",
    color: "#1a9fd4",
    bg: "#e8f6fc",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="6" y="6" width="12" height="12" rx="2.5" />
        <circle cx="9.5" cy="10" r="1" fill="currentColor" stroke="none" />
        <circle cx="14.5" cy="10" r="1" fill="currentColor" stroke="none" />
        <path d="M9 15h6M12 2v4M12 18v4M2 9h4M18 9h4M2 15h4M18 15h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Machine Learning",
    title: "Machine Learning",
    duration: "2 – 3 Months",
    stack: "Python, Scikit-learn, Pandas, Model Training",
    color: "#8451d8",
    bg: "#f1eafb",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="6" cy="6" r="2.2" />
        <circle cx="18" cy="6" r="2.2" />
        <circle cx="12" cy="13" r="2.2" />
        <circle cx="6" cy="19" r="2.2" />
        <circle cx="18" cy="19" r="2.2" />
        <path d="M7.6 7.4 10.4 11.6M16.4 7.4 13.6 11.6M10.4 14.4 7.6 17.6M13.6 14.4 16.4 17.6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Gen AI",
    title: "Gen AI",
    duration: "1 – 2 Months",
    stack: "LLMs, Prompting, RAG, AI App Building",
    color: "#e0703a",
    bg: "#fdece1",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3v3M12 18v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M3 12h3M18 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" strokeLinecap="round" />
        <circle cx="12" cy="12" r="3.4" />
      </svg>
    ),
  },
  {
    key: "Deep Learning",
    title: "Deep Learning",
    duration: "2 – 3 Months",
    stack: "Python, TensorFlow, Keras, Neural Nets",
    color: "#2f9e5b",
    bg: "#e6f6ec",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="4" cy="8" r="1.6" /><circle cx="4" cy="16" r="1.6" />
        <circle cx="12" cy="5" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="12" cy="19" r="1.6" />
        <circle cx="20" cy="8" r="1.6" /><circle cx="20" cy="16" r="1.6" />
        <path d="M5.4 8.7 10.6 5.6M5.4 8.7 10.6 11.5M5.4 15.3 10.6 12.4M5.4 15.3 10.6 18.4M13.4 5.6 18.6 8.7M13.4 12.4 18.6 8.7M13.4 12.4 18.6 15.3M13.4 18.4 18.6 15.3" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Data Science",
    title: "Data Science",
    duration: "2 – 3 Months",
    stack: "Python, Pandas, Statistics, Visualization",
    color: "#8451d8",
    bg: "#f1eafb",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 20V13M11 20V8M18 20v-6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Data Structure",
    title: "Data Structure",
    duration: "1 – 2 Months",
    stack: "Arrays, Trees, Graphs, Algorithms",
    color: "#1a9fd4",
    bg: "#e8f6fc",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="5" r="2" />
        <circle cx="6" cy="14" r="2" />
        <circle cx="18" cy="14" r="2" />
        <circle cx="12" cy="19" r="2" />
        <path d="M10.6 6.5 7.4 12.5M13.4 6.5 16.6 12.5M8 15.4 10.4 18M16 15.4 13.6 18" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Full Stack Development",
    title: "Full Stack Development",
    duration: "2 – 3 Months",
    stack: "React, Node.js, MongoDB, Express, HTML, CSS, JS",
    color: "var(--blue)",
    bg: "var(--blue-light)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M8 6 3 12l5 6M16 6l5 6-5 6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    key: "MERN/MEAN Stack",
    title: "MERN / MEAN Stack",
    duration: "2 – 3 Months",
    stack: "MongoDB, Express, React/Angular, Node.js",
    color: "#2f9e5b",
    bg: "#e6f6ec",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="12" rx="1.6" />
        <path d="M8 20h8M12 16v4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Web Development",
    title: "Web Development",
    duration: "1 – 2 Months",
    stack: "HTML, CSS, JavaScript, Responsive Design",
    color: "#e0b400",
    bg: "#fff7de",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.5 2.6 4 5.8 4 9s-1.5 6.4-4 9c-2.5-2.6-4-5.8-4-9s1.5-6.4 4-9Z" />
      </svg>
    ),
  },
  {
    key: "Flutter Development",
    title: "Flutter Development",
    duration: "2 – 3 Months",
    stack: "Dart, Flutter, Firebase, Mobile Apps",
    color: "#1a9fd4",
    bg: "#e8f6fc",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M6 14 15 5h5L11.5 13.5M6 14l4.5 4.5h5L11 14M6 14l4-4" strokeLinejoin="round" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "UI/UX Designing",
    title: "UI/UX Designing",
    duration: "1 – 2 Months",
    stack: "Figma, Wireframing, Prototyping, User Research",
    color: "#8451d8",
    bg: "#f1eafb",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="12" height="16" rx="1.6" />
        <circle cx="17.5" cy="15.5" r="3.5" />
        <path d="M9 8h2M9 11h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Graphic Designing",
    title: "Graphic Designing",
    duration: "1 – 2 Months",
    stack: "Photoshop, Illustrator, Canva, Branding",
    color: "#e0703a",
    bg: "#fdece1",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="9" cy="9" r="5.4" />
        <circle cx="15" cy="15" r="5.4" />
      </svg>
    ),
  },
  {
    key: "IoT",
    title: "IoT (Internet of Things)",
    duration: "2 – 3 Months",
    stack: "Arduino, Sensors, Embedded C, Connectivity",
    color: "#2f9e5b",
    bg: "#e6f6ec",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="2" />
        <path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5.6 5.6a9 9 0 0 0 0 12.8M18.4 5.6a9 9 0 0 1 0 12.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Content Writing",
    title: "Content Writing",
    duration: "1 – 2 Months",
    stack: "SEO Writing, Copywriting, Blogging, Editing",
    color: "#e0b400",
    bg: "#fff7de",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M5 4h11l3 3v13H5z" strokeLinejoin="round" />
        <path d="M9 10h6M9 13h6M9 16h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Digital Marketing",
    title: "Digital Marketing",
    duration: "1 – 2 Months",
    stack: "SEO, Social Media, Ads, Analytics",
    color: "var(--blue)",
    bg: "var(--blue-light)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M3 11v2l16 5V6L3 11Z" strokeLinejoin="round" />
        <path d="M8 13v5a2 2 0 0 0 4 0v-4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Business Software Training",
    title: "Business Software Training",
    duration: "1 Month",
    stack: "MS Office, Tally, ERP Basics, Documentation",
    color: "#1a9fd4",
    bg: "#e8f6fc",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="7" width="18" height="12" rx="1.5" />
        <path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Cyber Security",
    title: "Cyber Security",
    duration: "2 – 3 Months",
    stack: "Network Security, Ethical Hacking, Tools",
    color: "#e0703a",
    bg: "#fdece1",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z" strokeLinejoin="round" />
        <path d="M9.5 12l1.8 1.8L15 10.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    key: "Embedded",
    title: "Embedded Systems",
    duration: "2 – 3 Months",
    stack: "Embedded C, Microcontrollers, Circuit Design",
    color: "#8451d8",
    bg: "#f1eafb",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="7" y="7" width="10" height="10" rx="1.4" />
        <path d="M9 7V4M12 7V4M15 7V4M9 20v-3M12 20v-3M15 20v-3M7 9H4M7 12H4M7 15H4M20 9h-3M20 12h-3M20 15h-3" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    key: "Prompt Engineering",
    title: "Prompt Engineering",
    duration: "3 – 4 Weeks",
    stack: "LLMs, Prompt Design, AI Workflows",
    color: "#2f9e5b",
    bg: "#e6f6ec",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 6h13l3 3-3 3H4z" strokeLinejoin="round" />
        <path d="M8 9h6" strokeLinecap="round" />
      </svg>
    ),
  },
];

const WHY_US = [
  {
    title: "Real-world Projects",
    desc: "Work on practical projects used in real companies.",
    color: "var(--blue)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="7" width="18" height="12" rx="1.5" />
        <path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Expert Mentorship",
    desc: "Learn directly from industry experts and professionals.",
    color: "var(--orange)",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="8" cy="9" r="3" />
        <circle cx="17" cy="9" r="3" />
        <path d="M2.5 20c.6-3 2.8-5 5.5-5s4.9 2 5.5 5M12.5 20c.5-2.6 2.4-4.6 4.7-5 2.2.4 4 2.2 4.5 5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Hands-on Learning",
    desc: "Gain practical experience beyond classroom learning.",
    color: "#e0b400",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.5.4.8 1 .8 1.6V16h5.6v-.6c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3Z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Internship Certificate",
    desc: "Receive a certificate after successful completion.",
    color: "#8451d8",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="8" r="5" />
        <path d="M8.5 12.5 7 21l5-2.5L17 21l-1.5-8.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const JOURNEY = [
  { step: "01", title: "Apply", desc: "Submit your application and details.", color: "var(--blue)" },
  { step: "02", title: "Learn", desc: "Learn the technologies with expert guidance.", color: "var(--orange)" },
  { step: "03", title: "Build", desc: "Work on real projects and gain hands-on experience.", color: "#2f9e5b" },
  { step: "04", title: "Complete", desc: "Complete the internship and get certified.", color: "#8451d8" },
];

/* ── Custom domain dropdown ──
   Native <select> pops the OS's own list on mobile (grey, unstyled,
   overlaps nearby fields) — this button+list version stays inside the
   card, matches the brand styling, and closes on outside click / Escape. */
function DomainSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const selected = DOMAINS.find((d) => d.key === value);

  return (
    <div className="in-select" ref={wrapRef}>
      <button
        type="button"
        className={`in-select__trigger ${open ? "in-select__trigger--open" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className={selected ? "" : "in-select__placeholder"}>
          {selected ? selected.title : "Choose a domain"}
        </span>
        <svg className="in-select__chevron" viewBox="0 0 20 20" fill="none" width="16" height="16">
          <path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {open && (
        <ul className="in-select__list" role="listbox">
          {DOMAINS.map((d) => (
            <li
              key={d.key}
              role="option"
              aria-selected={d.key === value}
              className={`in-select__option ${d.key === value ? "in-select__option--active" : ""}`}
              onClick={() => { onChange(d.key); setOpen(false); }}
            >
              {d.title}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/* ── Apply modal — shared by every "Apply Now" button on the page ── */
function ApplyModal({ domain, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", domain: domain || "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // { type: 'ok' | 'err', text }

  /* Lock background scroll while the modal is open, and let Escape close it —
     otherwise the page behind can scroll independently of the fixed overlay
     and the card's own height can run past the viewport with no way back to
     its top (title/close button) or bottom (submit button). */
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };
  const handleDomainChange = (domainKey) => {
    setForm((f) => ({ ...f, domain: domainKey }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.phone.trim() || !form.domain) {
      setResult({ type: "err", text: "Please fill in name, email, phone and domain." });
      return;
    }
    setSubmitting(true);
    setResult(null);
    try {
      await submitInternshipApplication(form);
      setResult({ type: "ok", text: "Application submitted! We'll reach out to you shortly." });
    } catch (err) {
      setResult({ type: "err", text: err.message || "Could not submit your application. Please try again." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="in-modal" onClick={onClose}>
      <div className="in-modal__card" onClick={(e) => e.stopPropagation()}>

        {/* Sticky header — title + close (×) stay pinned even while the
            body below scrolls, so they're never lost off-screen. */}
        <div className="in-modal__header">
          <h3 className="in-modal__title">
            {result?.type === "ok" ? "Application Sent" : "Apply for Internship"}
          </h3>
          <button className="in-modal__close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="in-modal__body">
          {result?.type === "ok" ? (
            <div className="in-modal__success">
              <div className="in-modal__success-icon">✓</div>
              <p>{result.text}</p>
              <button className="in-btn in-btn--primary" onClick={onClose}>Close</button>
            </div>
          ) : (
            <>
              <p className="in-modal__sub">Fill in your details and we'll get back to you.</p>

              {result?.type === "err" && <div className="in-modal__error">{result.text}</div>}

              <form className="in-modal__form" onSubmit={handleSubmit}>
                <div className="in-field">
                  <label htmlFor="name">Full Name *</label>
                  <input id="name" name="name" value={form.name} onChange={handleChange} placeholder="Your name" />
                </div>
                <div className="in-field">
                  <label htmlFor="email">Email *</label>
                  <input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                </div>
                <div className="in-field">
                  <label htmlFor="phone">Phone *</label>
                  <input id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 98765 43210" />
                </div>
                <div className="in-field">
                  <label htmlFor="domain">Domain *</label>
                  <DomainSelect value={form.domain} onChange={handleDomainChange} />
                </div>
                <div className="in-field">
                  <label htmlFor="message">Message (optional)</label>
                  <textarea id="message" name="message" rows="3" value={form.message} onChange={handleChange} placeholder="Anything you'd like us to know" />
                </div>

                <button className="in-btn in-btn--primary in-modal__submit" type="submit" disabled={submitting}>
                  {submitting ? "Submitting…" : "Submit Application"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Internship() {
  const [applyDomain, setApplyDomain] = useState(null); // null = closed, "" = open with no preset, "X" = open preset to X
  const openApply = (domain = "") => setApplyDomain(domain);
  const closeApply = () => setApplyDomain(null);

  return (
    <div className="in-page">

      {/* ── HERO ── */}
      <section className="in-hero">
        <div className="in-hero__content">
          <span className="in-eyebrow">Internship Program</span>
          <h1 className="in-hero__heading">
            Build Skills.<br />
            Gain Experience.<br />
            <span className="in-accent">Start Your Career.</span>
          </h1>
          <p className="in-hero__sub">
            Join our internship programs and work on real projects with expert
            guidance to build your future.
          </p>
          <button className="in-btn in-btn--primary" onClick={() => openApply()}>
            Apply Now <span className="in-btn-arrow">→</span>
          </button>
        </div>
        <div className="in-hero__art" aria-hidden="true">
          
          <img
            className="in-hero__art-photo"
            src={teamHeroImg}
            alt="Interns collaborating"
          />
        </div>
      </section>

      {/* ── DOMAINS ── */}
      <section className="in-section">
        <div className="in-section__head">
          <span className="in-eyebrow">Our Internship Programs</span>
          <h2 className="in-heading">Choose Your Domain</h2>
        </div>

        <div className="in-domain-grid">
          {DOMAINS.map((d) => (
            <div className="in-domain-card" key={d.key}>
              <div className="in-domain-card__icon" style={{ color: d.color, background: d.bg }}>
                {d.icon}
              </div>
              <h3 className="in-domain-card__title">{d.title}</h3>
              <p className="in-domain-card__meta"><strong>Duration:</strong> {d.duration}</p>
              <p className="in-domain-card__stack">{d.stack}</p>
              <button
                className="in-domain-card__apply"
                style={{ color: d.color }}
                onClick={() => openApply(d.key)}
              >
                Apply Now <span className="in-btn-arrow">→</span>
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ── WHY US ── */}
      <section className="in-section in-section--alt">
        <div className="in-section__head">
          <span className="in-eyebrow">Why Internship With Us?</span>
          <h2 className="in-heading">Learn. Build. Grow.</h2>
        </div>

        <div className="in-why-grid">
          {WHY_US.map((w) => (
            <div className="in-why-card" key={w.title}>
              <div className="in-why-card__icon" style={{ color: w.color, background: `${w.color}1a` }}>
                {w.icon}
              </div>
              <h3 className="in-why-card__title">{w.title}</h3>
              <p className="in-why-card__desc">{w.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── JOURNEY ── */}
      <section className="in-section">
        <div className="in-section__head">
          <span className="in-eyebrow">How It Works</span>
          <h2 className="in-heading">Your Internship Journey</h2>
        </div>

        <div className="in-journey">
          {JOURNEY.map((j, i) => (
            <div className="in-journey__item" key={j.step}>
              <div className="in-journey__node" style={{ color: j.color, background: `${j.color}1a` }}>
                {j.step}
              </div>
              <h3 className="in-journey__title">{j.title}</h3>
              <p className="in-journey__desc">{j.desc}</p>
              {i < JOURNEY.length - 1 && <span className="in-journey__arrow" aria-hidden="true">→</span>}
            </div>
          ))}
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section className="in-cta">
        {/* <div className="in-cta__art in-cta__art--laptop" aria-hidden="true">💻</div> */}
        <div className="in-cta__content">
          <h2 className="in-cta__heading">Ready to Start Your Journey?</h2>
          <p className="in-cta__sub">Take the first step towards your dream career.</p>
          <button className="in-btn in-btn--primary" onClick={() => openApply()}>
            Apply for Internship <span className="in-btn-arrow">→</span>
          </button>
        </div>
        {/* <div className="in-cta__art in-cta__art--cap" aria-hidden="true">🎓</div> */}
      </section>

      {applyDomain !== null && <ApplyModal domain={applyDomain} onClose={closeApply} />}
    </div>
  );
}
